<div class="side-menu-branding">
   <img src="assets/man-insights.svg" height="50px;" alt="Deep Seeking"/>
</div>
<br/>
&nbsp;<img src="assets/cognitive.jpg" height="220px;" />

<ul class="side-menu-navigation nav flex-column">
  <li class="menu-item expandable-item nav-item" [routerLinkActive]="['active']">
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header class="menu-link">
        <div class="item-header-content">
          <mat-panel-title>
            <img src="assets/svg/red-person.svg" height="33px" class="menusvg" />
            <span class="menu-item-title">Personality</span>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>
      <ul class="menu-sub-navigation nav flex-column">
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/personality']">
     
            <span class="menu-item-title">Personality IQ</span>
          </a>
        </li>
   
      </ul>
    </mat-expansion-panel>
  </li>   <li class="menu-item expandable-item nav-item" [routerLinkActive]="['active']">
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header class="menu-link">
        <div class="item-header-content">
          <mat-panel-title>
         <img src="assets/svg/flask.svg" height="45px" class="menusvg" />
            <span class="menu-item-title">IQ Footprint</span>
          </mat-panel-title>
       
        </div>
      </mat-expansion-panel-header>
      <ul class="menu-sub-navigation nav flex-column">
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/lab']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Writing IQ</span>
          </a>
        </li>
   
      </ul>
    </mat-expansion-panel>
  </li>

  <li class="menu-item expandable-item nav-item" [routerLinkActive]="['active']">
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header class="menu-link">
        <div class="item-header-content">
          <mat-panel-title>
            &nbsp;&nbsp;&nbsp;<img src="assets/svg/clarichat.svg" height="42px" class="ai-brain menusvg" />
            <span class="menu-item-title">&nbsp;&nbsp;&nbsp;ClariChat</span>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>
      <ul class="menu-sub-navigation nav flex-column">
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/footprints/clari-chat']">
     
            <span class="menu-item-title">ClariChat</span>
          </a>
        </li>
    
      </ul>
    </mat-expansion-panel>
  </li> 
  

  <li class="menu-item expandable-item nav-item" [routerLinkActive]="['active']">
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header class="menu-link">
        <div class="item-header-content">
          <mat-panel-title>
            <img src="assets/img/redwomen.png" height="44px" class="menusvg" />
            <span class="menu-item-title">Image Studio </span>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>

      <ul class="menu-sub-navigation nav flex-column">
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/studio']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Stability Studio</span>
          </a>
        </li>
      </ul>
    </mat-expansion-panel>
  </li>
  <li class="menu-item expandable-item nav-item" [routerLinkActive]="['active']">
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header class="menu-link">
        <div class="item-header-content">
          <mat-panel-title>
            <img src="assets/svg/read-kid.svg" height="40px" class="menusvg" /> 
            <span class="menu-item-title">&nbsp;Reading Lab</span>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>
      <ul class="menu-sub-navigation nav flex-column">
     
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/read']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Educators</span>
          </a>
        </li>
          
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/read-plus']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Reading Levels</span>
          </a>
        </li>
      </ul>
    </mat-expansion-panel>
  </li>


  <li class="menu-item expandable-item nav-item" [routerLinkActive]="['active']">
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header class="menu-link">
     
        <div class="item-header-content">
          <mat-panel-title>
            <!-- <mat-icon class="menu-item-icon" svgIcon="forms"></mat-icon> -->
            &nbsp; <img src="assets/svg/duck.svg" height="43px" class="menusvg" /> &nbsp;&nbsp;
            <span class="menu-item-title">Witty Duck</span>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>
      <ul class="menu-sub-navigation nav flex-column">
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/wit']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Funny Duck</span>
          </a>
        </li>
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/ryhme']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Ryhming Duck</span>
          </a>
        </li>
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/inspire']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Inspirational Duck</span>
          </a>
        </li>
        <li class="menu-item nav-item" [routerLinkActive]="['active']">
          <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/song']">
            <i class="menu-item-icon"></i>
            <span class="menu-item-title">Song Duck</span>
          </a>
        </li>
  
      </ul>
    </mat-expansion-panel>
  </li>
  




</ul>
&nbsp;&nbsp;<img src="assets/dsd-logo.png" height="70px;" />